import type { BranchEntity } from "@/features/branch/domain/entities/BranchEntity"
import type { CategoryLevel } from "../enums/CategoryLevel"

export class AllCategoriesFilterEntity {
    id?: number
    parentId?: number 
    enabled?: boolean 
    isSensitive?: boolean 
    branch?: BranchEntity 
    level?: CategoryLevel 
    name?: string 
    searchWord?: string 
}